/**
 * [mscp_shop] size and price box ("Se storlekar & pris"): one box open at a time, closed by a
 * second click, a click outside or Esc. On phones (no button on the card) a tap anywhere on the
 * card outside the size link opens the popup, as the sketch has it.
 */
const OPEN = 'mscp-shop__sizes--open';

function closeAll(except = null) {
    document.querySelectorAll('.mscp-shop__sizes').forEach((box) => {
        if (box === except) return;
        box.classList.remove(OPEN);
        box.querySelector('.mscp-shop__sizebtn')?.setAttribute('aria-expanded', 'false');
        const tip = box.querySelector('.mscp-shop__tip');
        if (tip) tip.hidden = true;
    });
}

function init() {
    const shop = document.querySelector('.mscp-shop');
    if (!shop) return;

    shop.addEventListener('click', (e) => {
        const btn = e.target.closest('.mscp-shop__sizebtn');
        if (btn) {
            e.preventDefault();
            e.stopPropagation(); // never opens the popup
            const box = btn.closest('.mscp-shop__sizes');
            const tip = box.querySelector('.mscp-shop__tip');
            const open = !!tip.hidden;
            closeAll(box);
            tip.hidden = !open;
            box.classList.toggle(OPEN, open);
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            return;
        }
        // Phone: the whole card is the link.
        if (window.matchMedia('(max-width:700px)').matches && !e.target.closest('a,button,.mscp-shop__tip')) {
            const card = e.target.closest('.mscp-shop__card');
            const link = card?.querySelector('a.mscp-shop__panel[href]');
            if (link) link.click();
        }
    });
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.mscp-shop__sizes')) closeAll();
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeAll();
    });
}

export default { init };
